import { useRef, useEffect, useCallback } from 'react';

export const useVisibleDuration = (isVisible: boolean) => {
  const firstVisibleRef = useRef<number>(Date.now());

  useEffect(() => {
    if (isVisible) {
      firstVisibleRef.current = Date.now();
    }
  }, [isVisible]);

  return {
    firstVisible: firstVisibleRef.current,
    getDurationVisible: () => Date.now() - firstVisibleRef.current,
  };
};

export const useDuration = () => {
  const openedAtRef = useRef<number>(Date.now());

  const resetDuration = useCallback(() => {
    openedAtRef.current = Date.now();
  }, []);

  const getDurationOpen = useCallback(() => {
    return Date.now() - openedAtRef.current;
  }, []);

  return {
    openedAt: openedAtRef.current,
    getDurationOpen,
    resetDuration,
  };
};
